import React from 'react';

const WHATSAPP_SUPPORT = '+90 530 799 32 71';
// wa.me opens the WhatsApp app directly (or web.whatsapp.com on desktop) —
// a tel: link would just open a dial pad, which is not what "destek hattı" means here.
const WHATSAPP_LINK = 'https://wa.me/905307993271';

const faqItems = [
  { q: 'Çocuğumun performansını nasıl takip edebilirim?', a: 'Öğr. Performansı sayfasından çocuğunuzun detaylı performans grafiklerini inceleyebilirsiniz.' },
  { q: 'Randevu nasıl alabilirim?', a: 'Randevularım sayfasından mevcut randevuları görebilir ve yeni randevu talebi oluşturabilirsiniz.' },
  { q: 'Yeni öğrenci nasıl eklerim?', a: 'Anasayfa\'daki "Öğrenci Ekle" butonuna tıklayarak çocuğunuzun bilgilerini girin.' },
  { q: 'Öğretmenle nasıl iletişime geçebilirim?', a: 'Kurs İletişim Bilgileri bölümünden kurum ve öğretmen bilgilerine ulaşabilirsiniz.' },
  { q: 'Şifremi nasıl değiştirebilirim?', a: 'Birey Kimlik ile giriş yapıyorsanız şifreniz Birey Kimlik hesabınızda tutulur ve oradan değiştirilir; diğer hesaplarda Profil sayfasından güncelleyebilirsiniz.' },
];

const ParentHelp: React.FC = () => {
  return (
    <div>
      <h1 className="text-[20px] lg:text-[24px] font-semibold text-[#2b2b2b] mb-4 lg:mb-6">Yardım</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-5 mb-6 lg:mb-8">
        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#fafafa] rounded-[24px] p-5 lg:p-6 cursor-pointer hover:shadow-md transition-shadow block"
        >
          <div className="w-[48px] h-[48px] lg:w-[56px] lg:h-[56px] rounded-[12px] flex items-center justify-center mb-3 lg:mb-4" style={{ backgroundColor: '#3973bf' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
              <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="1.5" fill="none"/>
              <path d="M9 9a3 3 0 115.5 2c0 1.5-2.5 2-2.5 4" stroke="white" strokeWidth="1.5" fill="none"/>
              <circle cx="12" cy="18" r="1"/>
            </svg>
          </div>
          <p className="text-[16px] lg:text-[18px] font-semibold text-[#2b2b2b] mb-1">Destek Talebi</p>
          <p className="text-[13px] lg:text-[14px] text-gray-500 mb-2">Teknik sorunlar için destek ekibimize ulaşın</p>
          <p className="text-[13px] lg:text-[14px] font-semibold text-[#25D366]">WhatsApp destek hattı: {WHATSAPP_SUPPORT}</p>
        </a>
      </div>

      <h2 className="text-[18px] lg:text-[20px] font-semibold text-[#2b2b2b] mb-3 lg:mb-4">Sıkça Sorulan Sorular</h2>
      <div className="space-y-3">
        {faqItems.map((item, i) => (
          <details key={i} className="bg-[#fafafa] rounded-[24px] p-4 lg:p-5 group">
            <summary className="text-[14px] lg:text-[16px] font-semibold text-[#2b2b2b] cursor-pointer list-none flex items-center justify-between">
              {item.q}
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="transform group-open:rotate-180 transition-transform flex-shrink-0 ml-2">
                <path d="M5 8l5 5 5-5" stroke="#2b2b2b" strokeWidth="2"/>
              </svg>
            </summary>
            <p className="text-[13px] lg:text-[14px] text-gray-500 mt-3">{item.a}</p>
          </details>
        ))}
      </div>
    </div>
  );
};

export default ParentHelp;
